import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import {
  Button,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import styles from '../styles';
import { useTranslation } from 'react-i18next';
import IEnumeration from '../../../types/IEnumeration';
import CloseIcon from '@material-ui/icons/Close';
import { KeyedElement } from '../../AttributesDialog/hooks/useCollection';
import EnumerationsItem from './EnumerationsItem';

interface IEnumerationsTable {
  elements: KeyedElement<IEnumeration>[];
  editEnumerations: ({ index, field, value, regex, sizeLimit }) => void;
  addNewEnum: () => void;
  removeEnum: (index: number) => void;
  canAddNewEnum: (enums: IEnumeration[]) => boolean;
  disabled?: boolean;
}

const EnumerationsTable = ({
  elements,
  editEnumerations,
  addNewEnum,
  removeEnum,
  canAddNewEnum,
  disabled,
}: IEnumerationsTable) => {
  const classes = styles();

  const { t } = useTranslation();

  return (
    <TableContainer>
      <Table stickyHeader aria-label="sticky table" size="small" padding="none">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeaderCell}>
              Text
              <Typography
                variant="caption"
                component="span"
                className={classes.tableHeaderCaption}
              >
                Max 60 characters
              </Typography>
            </TableCell>
            <TableCell className={classes.tableHeaderCell} align="right">
              {!disabled && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={addNewEnum}
                  startIcon={<AddIcon />}
                  data-testid="new-enum-button"
                  disabled={!canAddNewEnum(elements)}
                  className={classes.buttonStyle}
                >
                  {t('attributes.button.add')}
                </Button>
              )}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {elements.map((element, index) => (
            <EnumerationsItem
              key={element.key}
              elements={elements}
              element={element}
              disabled={disabled}
              index={index}
              removeEnum={removeEnum}
              editEnumerations={editEnumerations}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

function DeleteEnum({
  removeEnum,
  index,
}: {
  removeEnum: (i: number) => void;
  index: number;
}) {
  return (
    <InputAdornment position="end">
      <IconButton aria-label="close" onClick={() => removeEnum(index)}>
        <CloseIcon opacity="0.5" />
      </IconButton>
    </InputAdornment>
  );
}

export default EnumerationsTable;
